
import React from 'react';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { EmailConfig } from '@/types/masterLicenseSettings';

interface EmailConfigItemProps {
  config: EmailConfig;
  onEdit: (configId: string) => void;
  onToggleActive: (configId: string, isActive: boolean) => void;
  onSetDefault: (configId: string) => void;
  onDelete: (configId: string) => void;
}

const EmailConfigItem: React.FC<EmailConfigItemProps> = ({
  config,
  onEdit,
  onToggleActive,
  onSetDefault,
  onDelete
}) => {
  return (
    <div key={config.id} className="border rounded-lg p-4 bg-card">
      <div className="flex justify-between items-start">
        <div>
          <div className="flex items-center space-x-2">
            <h4 className="font-medium">{config.name}</h4>
            {config.isDefault && (
              <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full">
                Default
              </span>
            )}
            {!config.isActive && (
              <span className="bg-muted text-muted-foreground text-xs px-2 py-1 rounded-full">
                Disabled
              </span>
            )}
          </div>
          <p className="text-sm text-muted-foreground">{config.fromEmail} ({config.provider})</p>
        </div>
        <div className="flex space-x-2">
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => onEdit(config.id)}
          >
            Edit
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => onToggleActive(config.id, config.isActive)}
          >
            {config.isActive ? 'Disable' : 'Enable'}
          </Button>
          {!config.isDefault && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => onSetDefault(config.id)}
            >
              Set as Default
            </Button>
          )}
          <Button 
            variant="ghost" 
            size="sm" 
            className="text-destructive hover:text-destructive hover:bg-destructive/10"
            onClick={() => onDelete(config.id)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailConfigItem;
